import { createFileRoute } from "@tanstack/react-router";

import SettlementDetail from "../components/SettlementDetail";

export const Route = createFileRoute("/households/$householdId/settlements/$settlementId")({
  component: SettlementRoute,
});

function SettlementRoute() {
  const { householdId, settlementId } = Route.useParams();
  return <SettlementDetail householdId={householdId} settlementId={settlementId} />;
}
